import React, { useMemo, useState } from 'react'
import { useI18n } from '../../../i18n/I18nContext'

export type AdminHelpTopic = {
  title: string
  purpose: string
  permissions: string
  nextActions: string[]
  safety: string
}

export const AdminHelp: React.FC<{
  topic: AdminHelpTopic
  showHelp: boolean
  onDismiss: () => void
}> = ({ topic, showHelp, onDismiss }) => {
  const { t } = useI18n()
  const [open, setOpen] = useState(showHelp)
  const panelId = useMemo(() => `admin-help-${topic.title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`, [topic.title])

  if (!showHelp) return null

  return (
    <aside className="admin-help" data-testid="admin-help">
      <button
        type="button"
        className="admin-help__trigger"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((current) => !current)}
      >
        ?
      </button>
      {open ? (
        <div id={panelId} className="admin-help__panel" role="region" aria-label={t('Contextual admin help')}>
          <div className="admin-help__header">
            <strong>{t(topic.title)}</strong>
            <button type="button" className="admin-help__dismiss" onClick={onDismiss}>{t('Hide help')}</button>
          </div>
          <p>{t(topic.purpose)}</p>
          <p>{t(topic.permissions)}</p>
          <ul>
            {topic.nextActions.map((action) => <li key={action}>{t(action)}</li>)}
          </ul>
          <p className="helper">{t(topic.safety)}</p>
        </div>
      ) : null}
    </aside>
  )
}
